module.exports = __webpack_public_path__ + "img/CardImage2.cffc15f9.png";